var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-05-26
 * @brief SEI 금일완료 결과 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState, curSchduleTreeState } from "../../../../recoil/assessmentState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { infoPop, reloadImage, reloadRight, reloadScroll, userInfoLoginState } from "../../../../recoil/userState";
// utils
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import { useDebounceEffect } from "./DaysMain";
// datepicker
import dayjs from "dayjs";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import ECharts from "echarts-for-react";
// 압축 다운로드
import axios from "axios";
import JSZip from "jszip";
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
function DailyInfoTodayDone(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [infoPopId, setInfoPopId] = useRecoilState(infoPop);
    const curTree = useRecoilValue(curSchduleTreeState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [reLoadScroll, setReLoadScroll] = useRecoilState(reloadScroll);
    const [reroadRights, setReroadRights] = useRecoilState(reloadRight);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, closePopup } = props;
    const scrollRef = useRef(null);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 500) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 500) {
            setMobile(true);
        }
    }), 100);
    const [checkResultItem, setCheckResultItme] = useState(null);
    const [totalComment, setTotalComment] = useState("");
    const [imageInfo, setImageInfo] = useState(null);
    const [groupName, setGroupName] = useState("");
    const [groupNameItem, setGroupNameItem] = useState([]);
    const [url, setUrl] = useState(null);
    const [instrumentAdd, setInstrumentAdd] = useState({
        testObject: "",
        name: "",
        manufacturer: "",
        serialNo: "",
    });
    const [instrumentEdit, setInstrumentEdit] = useState({
        instrumentId: 0,
        testObject: "",
        name: "",
        manufacturer: "",
        serialNo: "",
    });
    const [openCloseAdd, setOpenCloseAdd] = useState("");
    const [inspector, setInspector] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        // 계측기 등록
        handleOpenPop("pop-add-info", _jsx(CheckInstrumentAddPop, { instrumentAdd: instrumentAdd, setInstrumentAdd: setInstrumentAdd, errorList: errorList, setErrorList: setErrorList, onChangeTestObject: onChangeTestObject, onChangeName: onChangeName, check: check, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.계측기정보") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 계측기 수정
        handleOpenPop("pop-edit-info", _jsx(ChechItemUpdatepop, { instrumentEdit: instrumentEdit, setInstrumentEdit: setInstrumentEdit, errorList: errorList, setErrorList: setErrorList, onChangeTestObjectEdit: onChangeTestObjectEdit, onChangeNameEdit: onChangeNameEdit, check: check, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.계측기정보") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 개폐 횟수
        handleOpenPop("pop-add-num", _jsx(CheckOpenClosePop, { openCloseAdd: openCloseAdd, setOpenCloseAdd: setOpenCloseAdd, onChangeInput: onChangeInput, errorList: errorList, setErrorList: setErrorList, check: check, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.개폐횟수") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-num") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 점검자 수정
        handleOpenPop("pop-add-ins", _jsx(InspectorPop, { inspector: inspector, setInspector: setInspector, onChangeInspector: onChangeInspector, errorList: errorList, setErrorList: setErrorList, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.점검자") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-ins") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 이미지 수정
        handleOpenPop("pop-edit-image", _jsx(ImageEditPop, { imageInfo: imageInfo, groupName: groupName, setGroupName: setGroupName, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.사진제목") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-edit-image") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 이미지 삭제
        handleOpenPop("pop-delete-image", _jsx(ImageDeletePop, { imageInfo: imageInfo }));
        handleOpenPop("pop-img", _jsx(ImagePop, { url: url, htmlClose: _jsx(_Fragment, { children: _jsx("h1", { children: groupName }) }) }));
        // 종합의견 수정
        handleOpenPop("pop-memo", _jsx(TotalMemePop, { setTotalComment: setTotalComment, totalComment: totalComment, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.종합의견") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => TotalPopClose("pop-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 이미지 수정
        handleOpenPop("pop-edit-img", _jsx(TotalImagePop, { checkResultItem: checkResultItem, imageInfo: imageInfo, setImageInfo: setImageInfo, groupName: groupName, setGroupName: setGroupName, groupNameItem: groupNameItem, setGroupNameItem: setGroupNameItem, url: url, setUrl: setUrl }));
        //공유
        handleOpenPop("pop-share", _jsx(SharePop, { checkResultItem: checkResultItem }));
    }, []);
    // 종합 의견 닫기
    function TotalPopClose(id) {
        CUTIL.jsclose_Popup(id);
        setTotalComment(check.totalComment);
    }
    // 종합 의견 수정
    function TotalPopOn(e) {
        setTotalComment(check.totalComment);
        CUTIL.jsopen_Popup(e);
    }
    // 닫기 버튼
    function ClosePop(id) {
        if (id == "pop-add-info") {
            setInstrumentAdd({
                testObject: "",
                name: "",
                manufacturer: "",
                serialNo: "",
            });
        }
        else if (id == "pop-edit-info") {
            setInstrumentEdit(null);
        }
        else if (id == "pop-add-num" && check.countOpenClose <= 0) {
            setOpenCloseAdd("");
        }
        CUTIL.jsclose_Popup(id);
        setErrorList([]);
    }
    // 삭제 ,수정, 이미지 팝업
    function ImageInfo(e, item) {
        setGroupName(item.groupName);
        setImageInfo(item);
        setUrl(item.url);
        CUTIL.jsopen_Popup(e);
    }
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reLoadScroll + reroadRights + langIds,
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckResultItme(data.body);
                if (reLoadScroll) {
                    scrollRef.current.scrollTop = 0;
                    setReLoadScroll(false);
                }
                // 종합결과 이미지
                const totalImgName = data.body.image.map((item) => item.groupName);
                setGroupNameItem(totalImgName.filter((item, pos) => totalImgName.indexOf(item) === pos));
                setCheck(Object.assign(Object.assign({}, check), { totalComment: data.body.totalComment ? data.body.totalComment : "", isReportUpdated: data.body.isReportUpdated, countOpenClose: data.body.countOpenClose, assessmentInfo: {
                        isTempSave: data.body.isTempSave,
                        reportId: data.body.reportId,
                    } }));
                setReroadRights(false);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, reroadRights, langIds]);
    // 계측기 수정
    function ItemUpdatepop(e, item) {
        setInstrumentEdit({
            instrumentId: item.instrumentId,
            testObject: item.testObject,
            name: item.name,
            manufacturer: item.manufacturer,
            serialNo: item.serialNo,
        });
        CUTIL.jsopen_Popup(e);
    }
    // 개폐 횟수 등록, 수정
    function OpenCloseInfo(e, num) {
        if (check.countOpenClose > 0) {
            setOpenCloseAdd(num);
        }
        else {
            setOpenCloseAdd("");
        }
        CUTIL.jsopen_Popup(e);
    }
    function InspectorInfo(e, txt) {
        setInspector(txt);
        CUTIL.jsopen_Popup(e);
    }
    function onChangeTestObject(e) {
        setErrorList(errorList.filter((err) => err.field !== "testObject"));
        setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { testObject: e.target.value }));
    }
    function onChangeName(e) {
        setErrorList(errorList.filter((err) => err.field !== "name"));
        setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { name: e.target.value }));
    }
    function onChangeTestObjectEdit(e) {
        setErrorList(errorList.filter((err) => err.field !== "testObject"));
        setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { testObject: e.target.value }));
    }
    function onChangeNameEdit(e) {
        setErrorList(errorList.filter((err) => err.field !== "name"));
        setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { name: e.target.value }));
    }
    function onChangeInput(e) {
        setErrorList(errorList.filter((err) => err.field !== "openClose"));
        let value = e.target.value;
        let numValue = value.replace(/[^0-9]/g, "");
        if (numValue == value) {
            setOpenCloseAdd(numValue);
        }
        else {
            setErrorList([{ field: "openClose", msg: t("라벨.숫자만입력") }]);
        }
    }
    function onChangeInspector(e) {
        let value = e.target.value;
        setInspector(value);
        setErrorList(errorList.filter((err) => err.field !== "inspector"));
    }
    // ECahrt , data 반시계 반향으로 적용
    const barChartOption = {
        chart: {
            width: "100%",
        },
        title: {
        //text: '그룹별 점수'
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        legend: {
            icon: "circle",
            bottom: "0%",
            itemWidth: 14,
            itemHeight: 9,
            align: "auto",
        },
        grid: {
            top: "1%",
            left: "3%",
            right: "4%",
            bottom: "13%",
            containLabel: true,
            heigth: "100%",
        },
        xAxis: {
            type: "value",
            min: 0,
            boundaryGap: [0, 0.1],
        },
        yAxis: {
            type: "category",
            data: checkResultItem
                ? checkResultItem.chartData.map((item) => item.groupName)
                : [t("차트.사용연수"), t("차트.환경점검"), t("차트.육안점검"), t("차트.성능"), t("차트.기능")],
            axisLabel: {
                fontWeight: 500,
                fontFamily: "Noto Sans KR",
                fontSize: 14,
            },
        },
        series: [
            {
                name: t("라벨.평가점수"),
                type: "bar",
                color: "#0F5FA5",
                data: checkResultItem ? checkResultItem.chartData.map((item) => item.groupRateValue) : [0, 0, 0, 0, 0],
            },
            /*    {
                 name: '평균점수',
                 type: 'bar',
                 color: 'rgba(255, 103, 129, 0.5)',
                 data: (checkResultItem&& checkResultItem.chartData.length>0) ?
                   checkResultItem.chartData.map((item) => (item.avgScore)) : [0, 0, 0, 0, 0]
               } */
        ],
    };
    // ECahrt, data 반시계 반향으로 적용
    const radarChartOption = {
        chart: {
            width: "100%",
        },
        color: [
            "#B2C0DB",
            "#FF6781",
            "#0F5FA5", // VCB 평균 점수 Data
        ],
        legend: {
            icon: "circle",
            bottom: "1",
            itemWidth: 14,
            itemHeight: 9,
            align: "auto",
        },
        tooltip: {
            position: ["50%", "50%"],
        },
        radar: {
            // shape: 'circle',
            indicator: checkResultItem
                ? checkResultItem.chartData.map((item) => ({
                    name: item.groupName,
                    color: "black",
                }))
                : [
                    { name: t("차트.사용연수"), color: "black" },
                    { name: t("차트.환경점검"), color: "black" },
                    { name: t("차트.육안점검"), color: "black" },
                    { name: t("차트.성능"), color: "black" },
                    { name: t("차트.기능"), color: "black" },
                ],
            // 배경 간격
            splitNumber: 1,
            // 차트 max
            radius: 75,
            // startAngle: 90,
            //radar 사이 box style
            splitArea: {
                areaStyle: {
                    color: ["#FFF", "#FFF"],
                },
            },
            // 구분선 색상
            axisLine: {
                lineStyle: {
                    // color: '#2A2C2F'
                    color: "#C3CBD8",
                },
            },
            // 배경 라인 색상
            splitLine: {
                lineStyle: {
                    color: "#C3CBD8",
                },
            },
            // 배경 font
            axisName: {
                fontWeight: 500,
                fontFamily: "Noto Sans KR",
                fontSize: 11,
            },
        },
        series: {
            name: "Budget vs spending",
            type: "radar",
            data: [
                {
                    value: checkResultItem ? checkResultItem.chartData.map((item) => item.maxScore) : [100, 100, 100, 100, 100],
                    name: t("라벨.배점"),
                    symbol: "circle",
                    symbolSize: 6,
                },
                {
                    value: checkResultItem ? checkResultItem.chartData.map((item) => item.groupValue) : [0, 0, 0, 0, 0],
                    name: t("라벨.평가점수"),
                    symbol: "circle",
                    symbolSize: 6,
                },
                {
                    value: checkResultItem ? checkResultItem.chartData.map((item) => item.avgScore) : [0, 0, 0, 0, 0],
                    name: `${checkResultItem ? checkResultItem.item.spgName : "VCB"} ${t("라벨.평균점수")}`,
                    symbol: "circle",
                    symbolSize: 6,
                },
            ],
        },
    };
    function DownLoad(e) {
        HTTPUTIL.fileDownload_EhcReport(checkResultItem.item.itemName, checkResultItem.reportId, userInfo.loginInfo.token);
    }
    function ReportNewAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/report/pdf?assessmentId=${check.assessmentId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (!check.isReportUpdated) {
                        CUTIL.sleep(5000);
                    }
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.Report가발행되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReroadRights(true);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    let checkValuesByGroup = [];
    checkResultItem &&
        checkResultItem.chartData.map((item) => checkResultItem.checkValuesByGroup[item.groupName]
            .filter((nonf) => nonf.checkValue.action || nonf.checkValue.image.length > 0)
            .map((item) => checkValuesByGroup.push(item)));
    return (_jsx(_Fragment, { children: _jsxs(_Fragment, { children: [checkResultItem && (_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("p", Object.assign({ className: "box__title" }, { children: checkResultItem.item.itemName ? checkResultItem.item.itemName : "-" })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => closePopup("m-1650") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }))), _jsx("div", Object.assign({ ref: scrollRef, className: "box__body" }, { children: checkResultItem && (_jsxs("div", Object.assign({ className: "box-result" }, { children: [_jsx("div", Object.assign({ className: "box__header" }, { children: checkResultItem && (_jsxs("p", Object.assign({ className: "box__title" }, { children: [_jsxs("span", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: checkResultItem.checkSubTypeName ? checkResultItem.checkSubTypeName : "-" }), _jsx("span", { children: checkResultItem.versionNo })] })), _jsx("span", Object.assign({ className: "date" }, { children: dayjs(checkResultItem.updatedTime).format("YYYY-MM-DD") }))] }))) })), _jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.종합점수") })) })), _jsx("div", Object.assign({ className: "section-bottom" }, { children: _jsx("div", Object.assign({ className: "part" }, { children: _jsxs("div", Object.assign({ className: "total-score" }, { children: [_jsxs("div", Object.assign({ className: `score-top ${checkResultItem.alarmStatus == "WARNING_SCORE" ? "caution" : ""}` }, { children: [_jsxs("p", Object.assign({ className: "score" }, { children: [checkResultItem.totalScore, _jsx("span", { children: t("라벨.점") })] })), _jsxs("p", Object.assign({ className: "info" }, { children: [_jsx("span", Object.assign({ className: "tit" }, { children: checkResultItem.alarmStatus == "WARNING_SCORE" ? t("라벨.주의") : t("라벨.양호") })), _jsx("span", Object.assign({ className: "txt" }, { children: checkResultItem.alarmMessage }))] }))] })), _jsx("div", Object.assign({ className: "graph-area h200" }, { children: _jsx(ECharts, { option: barChartOption, style: { height: "100%", display: "block" } }) })), _jsx("div", Object.assign({ className: "graph-area h260" }, { children: _jsx(ECharts, { option: radarChartOption, style: { height: "100%", display: "block" } }) }))] })) })) }))] }), _jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.그룹별항목점수") })) })), _jsx("div", Object.assign({ className: "section-bottom" }, { children: checkResultItem.chartData &&
                                            checkResultItem.chartData.map((item, idx) => (_jsxs("div", Object.assign({ className: "part" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: item.groupName })) })), _jsx("div", Object.assign({ className: "tbl-list td-40" }, { children: _jsxs("table", Object.assign({ summary: "\uD3C9\uAC00\uB0B4\uC5ED,\uC810\uAC80\uACB0\uACFC,\uC810\uC218 \uD56D\uBAA9\uC73C\uB85C \uD658\uACBD\uC810\uAC80 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD658\uACBD\uC810\uAC80 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "60%" } }), _jsx("col", { style: { width: "27%" } }), _jsx("col", { style: { width: "13%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.평가내역") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.점검결과") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.점수") }))] }) }), _jsx("tbody", { children: checkResultItem.checkValuesByGroup[item.groupName].map((list, idx) => list.type !== 3 ? (_jsxs("tr", { children: [_jsx("td", { children: list.checkName }), _jsx("td", { children: _jsx("p", Object.assign({ className: `score-info
                                   ${list.checkValue.isChecked
                                                                                        ? "gray"
                                                                                        : list.checkValue.result == "불량"
                                                                                            ? "orange"
                                                                                            : list.checkValue.result == "주의필요"
                                                                                                ? "yellow"
                                                                                                : "green"}` }, { children: list.checkValue.isChecked ? t("라벨.판정불가") : list.checkValue.result })) }), _jsx("td", { children: list.checkValue.isChecked ? "-" : list.checkValue.value })] }, "check_list" + idx.toString())) : (_jsx("tr", { children: _jsxs("td", Object.assign({ colSpan: 3 }, { children: [_jsx("p", Object.assign({ className: "wmax-60p" }, { children: list.checkName })), _jsxs("div", Object.assign({ className: "score-line mt-10" }, { children: [_jsxs("ul", { children: [_jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx < 4)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measure }, "measure_" + i.toString()))) }), _jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx < 4)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measureValue }, "measureVal_" + i.toString()))) })] }), list.checkValue.checkRefValue.length > 4 && (_jsxs("ul", { children: [_jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx >= 4 && idx <= 7)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measure }, "measure_" + i.toString()))) }), _jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx >= 4 && idx <= 7)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measureValue }, "measureVal_" + i.toString()))) })] })), list.checkValue.checkRefValue.length >= 8 && (_jsxs("ul", { children: [_jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx >= 8)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measure }, "measure_" + i.toString()))) }), _jsx("li", { children: list.checkValue.checkRefValue
                                                                                                        .filter((_, idx) => idx >= 8)
                                                                                                        .map((val, i) => (_jsx("span", { children: val.measureValue }, "measureVal_" + i.toString()))) })] }))] }))] })) }, "check_list_type" + idx.toString()))) })] })) }))] }), "check_result_" + idx.toString()))) }))] }), checkValuesByGroup.length > 0 && (_jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.항목의견"), " ", _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", t("라벨.조치내용"), "/", t("라벨.첨부사진"), ")"] }))] })) })), checkResultItem.chartData.map((item) => checkResultItem.checkValuesByGroup[item.groupName]
                                        .filter((nonf) => nonf.checkValue.action || nonf.checkValue.image.length > 0)
                                        .map((list, idx) => {
                                        let images = list.checkValue.image.map((val) => val.groupName);
                                        let groupName = images.filter((item, pos) => images.indexOf(item) === pos);
                                        return (_jsxs("div", Object.assign({ className: "section-bottom" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: item.groupName })) })), _jsxs("div", Object.assign({ className: "part line" }, { children: [_jsx("p", Object.assign({ className: "tit-bar" }, { children: `${idx + 1}. ${list.checkName}` })), _jsxs("ul", Object.assign({ className: "detail-area" }, { children: [list.checkValue.action && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.조치내용") })), _jsx("div", Object.assign({ className: "txt-area" }, { children: _jsx("p", { children: list.checkValue.action }) }))] })), list.checkValue.image.length > 0 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.조치사진") })), _jsx("div", Object.assign({ className: "txt-area" }, { children: groupName.map((groupNames, i) => (_jsxs(React.Fragment, { children: [_jsxs("p", Object.assign({ className: "flex-inline left-right" }, { children: [_jsx("span", { children: groupNames }), _jsxs("span", Object.assign({ className: "txt-gray" }, { children: [list.checkValue.image.filter((img) => img.groupName === groupNames)
                                                                                                        .length, "/10"] }))] })), _jsx("div", Object.assign({ className: "img-area " }, { children: list.checkValue.image
                                                                                            .filter((img) => img.groupName === groupNames)
                                                                                            .map((chekImg, idx) => (_jsx(React.Fragment, { children: _jsx("img", { src: chekImg.url, style: {
                                                                                                    cursor: "pointer",
                                                                                                }, className: " js-open", "data-pop": "pop-img", onClick: (e) => ImageInfo(e, chekImg), alt: chekImg.name }, "check_img" + idx.toString()) }, "chekImg_" + idx.toString()))) }))] }, "groupNames_" + i.toString()))) }))] }))] }))] }))] }), "chekc_sub_" + idx.toString()));
                                    }))] })), _jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.종합의견") })) })), _jsxs("div", Object.assign({ className: "section-bottom" }, { children: [_jsxs("div", Object.assign({ className: "part" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.종합의견") })), _jsx("span", Object.assign({ className: "btn-area" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-memo", onClick: (e) => TotalPopOn(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }))] })), _jsx("ul", Object.assign({ className: "detail-area line" }, { children: _jsx("li", { children: _jsx("div", Object.assign({ className: "txt-area" }, { children: _jsx("textarea", { readOnly: true, value: checkResultItem.totalComment ? checkResultItem.totalComment : "" }) })) }) }))] })), _jsxs("div", Object.assign({ className: "part" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.현장사진") })), _jsx("span", Object.assign({ className: "btn-area" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-img", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })) }))] })), _jsx("ul", Object.assign({ className: "detail-area line" }, { children: checkResultItem.image.length > 0 &&
                                                            groupNameItem &&
                                                            groupNameItem.map((groupNames, idx) => (_jsx("li", { children: _jsxs("div", Object.assign({ className: "txt-area" }, { children: [_jsx("p", Object.assign({ className: "flex-inline left-right" }, { children: _jsx("span", { children: groupNames }) })), _jsx("div", Object.assign({ className: "img-area" }, { children: checkResultItem.image
                                                                                .filter((img) => img.groupName === groupNames)
                                                                                .map((img, index) => (_jsx("img", { src: img.url, alt: img.name, className: " js-open", "data-pop": "pop-img", onClick: (e) => ImageInfo(e, img) }, "imgs_" + index.toString()))) }))] })) }, "assImg_" + idx.toString()))) }))] }))] }))] }), _jsxs("section", { children: [_jsx("div", Object.assign({ className: "section-top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.기본정보") })) })), _jsxs("div", Object.assign({ className: "section-bottom" }, { children: [_jsxs("div", Object.assign({ className: "part" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.설비정보") })) })), _jsx("div", Object.assign({ className: "tbl-list row td-40" }, { children: _jsxs("table", Object.assign({ summary: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC124\uBE44 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.형명") })), _jsx("td", { children: checkResultItem.item.itemName ? checkResultItem.item.itemName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.판넬명") })), _jsx("td", { children: checkResultItem.item.panelName ? checkResultItem.item.panelName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.시리얼번호") })), _jsx("td", { children: checkResultItem.item.serialNo ? checkResultItem.item.serialNo : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조사") })), _jsx("td", { children: "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.제조년월") })), _jsx("td", { children: checkResultItem.item.madeYearAndMonth ? checkResultItem.item.madeYearAndMonth : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.분전소명") })), _jsx("td", { children: checkResultItem.item.roomName ? checkResultItem.item.roomName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.설비유형") })), _jsx("td", { children: checkResultItem.item.spgName ? checkResultItem.item.spgName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.수용가") })), _jsxs("td", { children: [" ", checkResultItem.item.companyName ? checkResultItem.item.companyName : "-"] })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.개폐횟수") })), _jsx("td", { children: _jsxs("p", Object.assign({ className: "flex-inline" }, { children: [checkResultItem.countOpenClose ? checkResultItem.countOpenClose : "", _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g ml-10 js-open", "data-pop": "pop-add-num", onClick: (e) => OpenCloseInfo(e, checkResultItem.countOpenClose ? checkResultItem.countOpenClose : 0) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) }))] })) })] })] })] })) }))] })), _jsxs("div", Object.assign({ className: "part" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.검사정보") })) })), _jsx("div", Object.assign({ className: "tbl-list row td-40" }, { children: _jsxs("table", Object.assign({ summary: "\uAC80\uC0AC \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uAC80\uC0AC \uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.검사유형") })), _jsx("td", { children: checkResultItem.checkTypeName ? checkResultItem.checkTypeName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.상세유형") })), _jsx("td", { children: checkResultItem.checkSubTypeName ? checkResultItem.checkSubTypeName : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.점검일자") })), _jsx("td", { children: checkResultItem.updatedTime
                                                                                        ? dayjs(checkResultItem.updatedTime).format("YYYY-MM-DD")
                                                                                        : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.시행사") })), _jsx("td", { children: checkResultItem.inspectorCompany ? checkResultItem.inspectorCompany : "-" })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.점검자") })), _jsx("td", { children: _jsxs("p", Object.assign({ className: "flex-inline" }, { children: [checkResultItem.inspector ? checkResultItem.inspector : "-", _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g ml-8 js-open", "data-pop": "pop-add-ins", onClick: (e) => InspectorInfo(e, checkResultItem.inspector ? checkResultItem.inspector : "") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) }))] })) })] }), _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "row" }, { children: t("라벨.조치건수") })), _jsxs("td", { children: [checkResultItem.actionCount !== null ? checkResultItem.actionCount : "-", t("라벨.개")] })] })] })] })) }))] })), _jsxs("div", Object.assign({ className: `part ${checkResultItem.instrument.length <= 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top mb-8" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.계측기정보") })), _jsxs("div", Object.assign({ className: "flex-right" }, { children: [checkResultItem.instrument.length > 0 && _jsx("p", { children: checkResultItem.instrument.length + "개" }), _jsx("button", Object.assign({ type: "button", className: "btn btn-more js-open", "data-pop": "pop-add-info", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uCD94\uAC00" })) }))] }))] })), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.계측기정보가없습니다") })), _jsx("div", Object.assign({ className: "tbl-list tbl-border" }, { children: _jsxs("table", Object.assign({ summary: "\uACC4\uCE21\uAE30 \uC815\uBCF4 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uACC4\uCE21\uAE30\uC815\uBCF4 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "50%" } }), _jsx("col", { style: { width: "50%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.시험항목") })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.사용계측기형명") }))] }) }), _jsx("tbody", { children: checkResultItem.instrument.length > 0 ? (checkResultItem.instrument.map((ck, idx) => (_jsxs("tr", { children: [_jsx("td", { children: _jsxs("div", Object.assign({ className: "flex-inline left-right" }, { children: [_jsx("p", Object.assign({ className: "ellipsis" }, { children: ck.testObject })), _jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-info", onClick: (e) => ItemUpdatepop(e, ck) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) }))] })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: ck.name })) })] }, "inst_" + idx.toString())))) : (_jsx("tr", { children: _jsx("td", Object.assign({ colSpan: 2 }, { children: _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.계측기정보가없습니다") })) })) })) })] })) }))] }))] }))] }), _jsxs("div", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-share", onClick: (e) => CUTIL.jsopen_Popup(e), disabled: check.assessmentInfo.reportId > 0 ? false : true }, { children: _jsx("span", { children: t("라벨.공유") }) })), !check.isReportUpdated ? (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => ReportNewAdd(e) }, { children: _jsx("span", { children: t("라벨.레포트발행") }) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => DownLoad(e) }, { children: _jsx("span", { children: "PDF Download" }) }))), _jsx("button", Object.assign({ type: "button", disabled: true, className: "btn-basic" }, { children: _jsx("span", { children: t("라벨.점검요청") }) }))] }))] }))) }))] }) }));
}
export default DailyInfoTodayDone;
function CheckInstrumentAddPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reloadRight);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { instrumentAdd, setInstrumentAdd, errorList, setErrorList, onChangeTestObject, onChangeName } = props;
    function instrumentAddClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/assessment/${check.assessmentId}/instrument`,
                appQuery: {
                    testObject: instrumentAdd.testObject,
                    name: instrumentAdd.name,
                    manufacturer: instrumentAdd.manufacturer,
                    serialNo: instrumentAdd.serialNo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    PopClose("pop-add-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-info", type: CONST.TYPE_INNRE, divTag: t("라벨.계측기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setInstrumentAdd({
            testObject: "",
            name: "",
            manufacturer: "",
            serialNo: "",
        });
        setErrorList([]);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시험명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.ex절연내압시험"), value: instrumentAdd.testObject, onChange: (e) => onChangeTestObject(e), className: errorList.filter((err) => err.field === "testObject").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "testObject").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.계측기형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.name, onChange: (e) => onChangeName(e), className: errorList.filter((err) => err.field === "name").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.manufacturer, onChange: (e) => setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { manufacturer: e.target.value })) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.시리얼번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentAdd.serialNo, onChange: (e) => setInstrumentAdd(Object.assign(Object.assign({}, instrumentAdd), { serialNo: e.target.value })) }) }))] })] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => PopClose("pop-add-info") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => instrumentAddClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
function ChechItemUpdatepop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reloadRight);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { instrumentEdit, setInstrumentEdit, errorList, setErrorList, onChangeTestObjectEdit, onChangeNameEdit } = props;
    // 계측기 수정
    function instrumentEditClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (instrumentEdit.testObject && instrumentEdit.name) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/assessment/instrument/${instrumentEdit.instrumentId}`,
                    appQuery: {
                        testObject: instrumentEdit.testObject,
                        name: instrumentEdit.name,
                        manufacturer: instrumentEdit.manufacturer,
                        serialNo: instrumentEdit.serialNo,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-edit-info");
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: "계측기가 수정 되었습니다." }));
                        setErrorList([]);
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                        setReload(false);
                    }
                    else {
                        // need error handle
                        if (data.errorList) {
                            setErrorList(data.errorList);
                        }
                        else {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
            }
        });
    }
    // 계측기 삭제
    function instrumentDeleteClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/assessment/instrument/${instrumentEdit.instrumentId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-edit-info");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-info", type: CONST.TYPE_INNRE, divTag: data.body }));
                    setErrorList([]);
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-info");
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시험명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.ex절연내압시험"), value: instrumentEdit.testObject, className: errorList.filter((err) => err.field === "testObject").length > 0 ? "input-error" : "", onChange: (e) => onChangeTestObjectEdit(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "testObject").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.계측기형명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.name, className: errorList.filter((err) => err.field === "name").length > 0 ? "input-error" : "", onChange: (e) => onChangeNameEdit(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "name").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.manufacturer, onChange: (e) => setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { manufacturer: e.target.value })) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.시리얼번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: instrumentEdit.serialNo, onChange: (e) => setInstrumentEdit(Object.assign(Object.assign({}, instrumentEdit), { serialNo: e.target.value })) }) }))] })] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => instrumentDeleteClick(e) }, { children: _jsx("span", { children: t("라벨.삭제") }) })), _jsx("button", Object.assign({ type: "button", className: "", onClick: (e) => instrumentEditClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
function InspectorPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const setReload = useSetRecoilState(reloadRight);
    const [alert, setAlert] = useRecoilState(alertState);
    // props
    const { inspector, setInspector, onChangeInspector, errorList, setErrorList } = props;
    // 점검자 수정
    function inspectorClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!inspector) {
                setErrorList([{ field: "inspector", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
            }
            else {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/assessment/${check.assessmentId}`,
                    appQuery: {
                        inspector: inspector,
                        isTempSave: false,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-ins", type: CONST.TYPE_INNRE, divTag: t("라벨.점검자가수정되었습니다") }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-ins");
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        setInspector("");
        setErrorList([]);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input mt-0" }, { children: _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.점검자"), " \uC774\uB984"] })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.이름입력"), className: errorList.filter((err) => err.field === "inspector").length > 0 ? "input-error" : "", value: inspector, onChange: (e) => onChangeInspector(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "inspector").map((err) => err.msg) }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => PopClose("pop-add-ins") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => inspectorClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
function CheckOpenClosePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const setReload = useSetRecoilState(reloadRight);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { openCloseAdd, setOpenCloseAdd, onChangeInput, errorList, setErrorList } = props;
    // 계측횟수 등록, 수정
    function openCloseClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!openCloseAdd) {
                setErrorList([{ field: "openClose", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
            }
            else {
                setRecoilIsLoadingBox(true);
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/assessment/${check.assessmentId}`,
                    appQuery: {
                        countOpenClose: openCloseAdd,
                        isTempSave: false,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        PopClose("pop-add-num");
                        if (check.countOpenClose <= 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-num", type: CONST.TYPE_INNRE, divTag: t("라벨.개폐횟수가등록되었습니다") }));
                            CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-num");
                        }
                        else {
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-num", type: CONST.TYPE_INNRE, divTag: t("라벨.개폐횟수가수정되었습니다") }));
                            if (check.isReportUpdated) {
                                CUTIL.sleep(5000);
                            }
                            CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-num");
                        }
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.jsclose_Popup(id);
        if (check.countOpenClose > 0) {
            setOpenCloseAdd(check.countOpenClose);
        }
        else {
            setOpenCloseAdd("");
        }
        setErrorList([]);
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input mt-0" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.개폐횟수") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.횟수를입력하세요"), className: errorList.filter((err) => err.field === "openClose").length > 0 ? "input-error" : "", value: openCloseAdd, onChange: (e) => onChangeInput(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "openClose").map((err) => err.msg) }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => PopClose("pop-add-num") }, { children: _jsx("span", { children: t("라벨.취소") }) })), check.countOpenClose <= 0 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => openCloseClick(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))) : (_jsx("button", Object.assign({ type: "button", onClick: (e) => openCloseClick(e) }, { children: _jsx("span", { children: t("라벨.수정") }) })))] }))] }));
}
// 이미지 전체 수정
function TotalImagePop(props) {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const setReload = useSetRecoilState(reloadRight);
    const [reloadImages, setReloadImages] = useRecoilState(reloadImage);
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { setImageInfo, setGroupName, setUrl } = props;
    // useState
    const [uploadFiles, setUploadFiles] = useState([]);
    const [potoName, setPotoName] = useState("");
    const [file, setFile] = useState([]);
    const lastNum = 10;
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reloadImages + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                // 종합결과 이미지
                setUploadFiles(data.body.image);
                setReloadImages(false);
            }
        }
    }, [data, reloadImages, langIds]);
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
            }
            setFile([...imageUpload]);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(delFile) {
        setFile(file.filter((file) => file.name !== delFile.name));
    }
    // 첨부파일 업로드
    function uploadFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!potoName) {
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.사진제목입력") }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                if (file.length + uploadFiles.length <= lastNum) {
                    setRecoilIsLoadingBox(true);
                    const formData = new FormData();
                    // 파일 데이터 저장
                    file.map((files) => formData.append("files", files));
                    let data = null;
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POSTF",
                        appPath: `/images/assessment?assessmentId=${check.assessmentId}&groupName=${potoName}`,
                        appQuery: formData,
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            setReloadImages(true);
                            setPotoName("");
                            setFile([]);
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setRecoilIsLoadingBox(false);
                        }
                        else {
                            // need error handle
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : t("라벨.사진첨부하세요") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setRecoilIsLoadingBox(false);
                        }
                    }
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: "첨부파일은 10개 까지 가능합니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    // 삭제, 수정, 이미지 팝업
    function ImageInfo(e, id, item) {
        setGroupName(item.groupName);
        setImageInfo(item);
        setUrl(item.url);
        CUTIL.jsopen_InnerPopup(id, "pop-edit-img");
    }
    function ImageClose(id) {
        CUTIL.jsclose_Popup(id);
        setFile([]);
        setPotoName("");
    }
    function ImageSave(id) {
        setReload(true);
        CUTIL.jsclose_Popup(id);
        setFile([]);
        setPotoName("");
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("h2", { children: t("라벨.사진파일업로드") }), _jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제목") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp", placeholder: t("라벨.사진제목입력"), value: potoName, onChange: (e) => setPotoName(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.파일불러오기") })), _jsxs("div", Object.assign({ className: "input__area add-file" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", readOnly: true, placeholder: t("라벨.사진첨부하세요") }), _jsx("label", Object.assign({ htmlFor: "file" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부500MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), "img_" + idx.toString()))) })), _jsx("div", Object.assign({ className: "flex-inline right mt-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => uploadFileImage(e) }, { children: _jsx("span", { children: t("라벨.업로드") }) })) }))] }))] })] })), _jsxs("div", Object.assign({ className: "imglist" }, { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: t("라벨.첨부사진내역") }), _jsxs("span", { children: [uploadFiles.length, "/10"] })] })), _jsx("ul", Object.assign({ className: "imgbox-area" }, { children: uploadFiles.map((img, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [_jsx("span", { children: img.groupName }), _jsxs("span", Object.assign({ className: "btn-area" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit-g js-open", "data-pop": "pop-edit-image", onClick: (e) => ImageInfo(e, "pop-edit-image", img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete-image", onClick: (e) => ImageInfo(e, "pop-delete-image", img) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }))] })), _jsx("div", Object.assign({ className: "img-area js-open", "data-pop": "pop-img", onClick: (e) => ImageInfo(e, "pop-img", img) }, { children: _jsx("img", { src: img.url, alt: img.name }) }))] }, "imgs_" + idx.toString()))) }))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => ImageClose("pop-edit-img") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ImageSave("pop-edit-img") }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] }));
}
//이미지 제목
function ImageEditPop(props) {
    const t = useTrans();
    // recoil
    const [alert, setAlert] = useRecoilState(alertState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reloadImage);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { imageInfo, groupName, setGroupName } = props;
    function listEidt(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/image/checkvalue/groupName/${imageInfo.imageId}`,
                appQuery: {
                    groupName: groupName,
                },
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_InnerPopup("pop-edit-image", "pop-edit-img");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-img", type: CONST.TYPE_ERROR, divTag: t("라벨.수정되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-img");
                    setReload(false);
                }
                setRecoilIsLoadingBox(false);
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp2", value: groupName, onChange: (e) => setGroupName(e.target.value) }) })) }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray ", onClick: (e) => CUTIL.jsclose_InnerPopup("pop-edit-image", "pop-edit-img") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listEidt(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ImageDeletePop(props) {
    const t = useTrans();
    // recoil
    const [alert, setAlert] = useRecoilState(alertState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reloadImage);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { imageInfo } = props;
    function listDel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/image/${imageInfo.imageId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: imageInfo,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_InnerPopup("pop-delete-image", "pop-edit-img");
                    if (CUTIL.jsclose_InnerPopup.name == "pop-delete-image") {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete-image", type: CONST.TYPE_INNRE, divTag: data.body }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete-image");
                        setReload(false);
                    }
                    if (CUTIL.jsclose_InnerPopup.name == "pop-edit-img") {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-edit-img", type: CONST.TYPE_INNRE, divTag: data.body }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-edit-img");
                        setReload(false);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.첨부된사진을삭제하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray ", onClick: (e) => CUTIL.jsclose_InnerPopup("pop-delete-image", "pop-edit-img") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => listDel(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
// 이미지 확대 팝업
function ImagePop(props) {
    const t = useTrans();
    const { url } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("div", Object.assign({ className: "img-area" }, { children: _jsx("img", { src: url, alt: "\uBD84\uC804\uC18C \uC628\uB3C4 \uC0AC\uC9C4" }) })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-img") }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
// 종합의견 수정
function TotalMemePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reloadRight);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    // props
    const { setTotalComment, totalComment } = props;
    function MemoClose(id) {
        CUTIL.jsclose_Popup(id);
        setTotalComment(check.totalComment);
    }
    function MemoUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/assessment/${check.assessmentId}`,
                appQuery: {
                    totalComment: totalComment,
                    isTempSave: false,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-memo");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-memo", type: CONST.TYPE_INNRE, divTag: t("라벨.내용이수정되었습니다") }));
                    if (check.isReportUpdated) {
                        CUTIL.sleep(5000);
                    }
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-memo");
                    setCheck(Object.assign(Object.assign({}, check), { totalComment: data.body.totalComment }));
                    setRecoilIsLoadingBox(false);
                    setReload(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            setReload(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h170", value: totalComment, onChange: (e) => setTotalComment(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 1000), onKeyUp: (e) => CUTIL.afterHandleComment(e, 1000, setTotalComment) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [totalComment ? totalComment.length : 0, " / 1000"] }))] })) }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsxs("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => MemoClose("pop-memo") }, { children: [" ", _jsx("span", { children: t("라벨.취소") })] })), _jsx("button", Object.assign({ type: "button", onClick: (e) => MemoUpdate(e) }, { children: _jsx("span", { children: t("라벨.수정") }) }))] }))] }));
}
function SharePop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [check, setCheck] = useRecoilState(checkTypeState);
    const langIds = useRecoilValue(langId);
    // props
    const { checkResultItem } = props;
    const [checkItem, setCheckItem] = useState([]);
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/assessment${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCheckItem([data.body]);
            }
        }
    }, [data, langIds]);
    const [toMails, setToMails] = useState("");
    const [errorList, setErrorList] = useState([]);
    function shareClose(id) {
        CUTIL.jsclose_Popup(id);
        setToMails("");
    }
    function handleSetUserId(e) {
        setErrorList(errorList.filter((err) => err.field !== "email"));
        setToMails(e.target.value);
    }
    // PDF다운로드
    function handleZipDownload(e) {
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = `${t("라벨.진단점검리포트")}.zip`;
        setRecoilIsLoadingBox(true);
        checkItem.map((list, idx) => __awaiter(this, void 0, void 0, function* () {
            yield getSecondFileUrl(list)
                .then((val) => {
                if (val.codeNum === 200) {
                    zipList = zipList.concat({
                        fileName: `${list.item.itemName + "_" + idx}_${t("라벨.진단점검리포트")}.PDF`,
                        fileLink: val.body.fileLink,
                    });
                }
                return {
                    codeNum: val.codeNum,
                    fileName: `${list.item.itemName + "_" + idx}_${t("라벨.진단점검리포트")}.PDF`,
                    fileLink: val.body.fileLink,
                };
            })
                .then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    })
                        .then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    })
                        .then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                const email = { email: toMails };
                                linkShare(zipFileName, email, blob); // 공유 연결시 해당 부분 변경
                            });
                        }
                    });
                }
            });
        }));
    }
    function getSecondFileUrl(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/report/${list.reportId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            return data;
        });
    }
    function linkShare(zipFileName, email, content) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            const formData = new FormData();
            // 파일 데이터 저장
            const blob = new Blob([JSON.stringify(email)], {
                type: "application/json",
            });
            formData.append("email", blob);
            formData.append("file", content, zipFileName);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/assessment/report/zip/email`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-share");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.body }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setToMails("");
                }
                else {
                    if (toMails == "") {
                        setErrorList([{ field: "email", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
                    }
                    else {
                        if (data.errorList) {
                            setErrorList(data.errorList);
                        }
                        else {
                        }
                    }
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input w85p" }, { children: _jsxs("li", Object.assign({ className: "center" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "E-Mail" })), _jsxs("div", Object.assign({ className: "input__area w260" }, { children: [_jsx("input", { type: "text", id: "userId0", placeholder: "공유하실 이메일주소를 입력하세요.", className: errorList.filter((err) => err.field === "email").length > 0 ||
                                            errorList.filter((err) => err.field === "mail").length > 0
                                            ? "input-error"
                                            : "", value: toMails, onChange: (e) => handleSetUserId(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "email").map((err) => err.msg).length > 0 ||
                                            errorList.filter((err) => err.field === "mail").map((err) => err.msg) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => shareClose("pop-share") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => handleZipDownload(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
